export default abstract class SelectValues {
    get label(): string {
        // @ts-ignore
        return this.name;
    }

    get value(): number {
        // @ts-ignore
        return this.id;
    }
}
